exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-btn {\n  font-size: 16.5px !important;\n  line-height: 48px !important;\n  transition-property: color, background-color, border-color, box-shadow !important;\n  width: 100% !important;\n  border-radius: 0 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Login/components/ButtonLogin/ButtonLogin.less
// module id = 1051
// module chunks = 0